import { Guid, ITranslations } from "@/types"
import { IGetFreightUnit } from "./Asset"

export interface IGetLmidAssetDto {
    tenantId: Guid
    features?: ITranslations | null
    freightUnits?: IGetFreightUnit[] | null
    width?: number | null
    height?: number | null
    length?: number | null
    weight?: number | null
    volume?: number | null
    emissionLevel?: string | null
    colorId?: Guid | null
    measurementSystemId?: Guid | null
    quickCouplingSystem?: string | null
    connectionType?: string | null
    cuttingEdge?: boolean | null
    teeth?: boolean | null
    heavyDuty?: boolean | null
    locking?: string | null
    controlSystem?: string | null
    agility?: string | null
}

export default class LmidAsset {
    tenantId: Guid
    features?: ITranslations
    freightUnits: IGetFreightUnit[]
    width?: number
    height?: number
    length?: number
    weight?: number
    volume?: number
    emissionLevel?: string
    colorId?: Guid
    measurementSystemId?: Guid
    quickCouplingSystem?: string | null
    connectionType?: string | null
    cuttingEdge?: boolean | null
    teeth?: boolean | null
    heavyDuty?: boolean | null
    locking?: string | null
    controlSystem?: string | null
    agility?: string | null

    constructor(dto: IGetLmidAssetDto) {
        this.tenantId = dto.tenantId
        this.features = dto.features ?? undefined
        this.freightUnits = dto.freightUnits || []
        this.width = typeof dto.width === "number" ? dto.width : undefined
        this.height = typeof dto.height === "number" ? dto.height : undefined
        this.length = typeof dto.length === "number" ? dto.length : undefined
        this.weight = typeof dto.weight === "number" ? dto.weight : undefined
        this.volume = typeof dto.volume === "number" ? dto.volume : undefined
        this.emissionLevel = dto.emissionLevel ?? undefined
        this.colorId = dto.colorId ?? undefined
        this.measurementSystemId = dto.measurementSystemId ?? undefined
        this.quickCouplingSystem = dto.quickCouplingSystem ?? undefined
        this.connectionType = dto.connectionType ?? undefined
        this.cuttingEdge = dto.cuttingEdge ?? undefined
        this.teeth = dto.teeth ?? undefined
        this.heavyDuty = dto.heavyDuty ?? undefined
        this.locking = dto.locking ?? undefined
        this.controlSystem = dto.controlSystem ?? undefined
        this.agility = dto.agility ?? undefined
    }
}
